import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import Datatable from '../component/Datatable';
import {UserList,blockUser} from '../Services/User';
import {AuthData} from '../Services/Authdata';
import MaterialIcons from '../component/MaterialIcons';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import {Link} from 'react-router-dom';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));


export default function User() {
  const br = [{
    'title':'User',
    'icon':"",
    'url':'/user'
  }];
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [srow, setSrow] = useState([]);
  useEffect(() =>{
    UserList('user/list','GET',AuthData().token).then((result)=>{
      setData(result.data);
    })
  },[])
  const userBlock =(type,userId)=>{
   // console.log(userId)
    if(type === 0){
      var mess = "Unblock";
    }else{
       mess = "Block";
    }
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to "+mess+" the user",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok'
    }).then((result) => {
      if (result.value) {
        blockUser('GET','user/block_user?id=['+userId+']&type='+type,AuthData().token)
        .then((result)=>{
          if(result.status === 1){
            Swal.fire(
              'Success!',
              result.message,
              'success'
            )
            UserList('user/list','GET',AuthData().token).then((result)=>{
              //console.log(result);
              setData(result.data);
            })
          }else{
            Swal.fire(
              'Success!',
              result.message,
              'success'
            )
          }
          
        })
        
      }
    })
  }
  const columns = [
    {
     name: "user_name",
     label: "Name",
     options: {
      filter: true,
      sort: true,
      customBodyRenderLite:(value, dataIndex,updateValue) => {
          return <span style={{display:'flex'}}>
            <Avatar title={data[dataIndex].user_name} alt={data[dataIndex].user_name} src={data[dataIndex].profile_pic} />
            <h4 style={{marginTop:"10px"}}>{data[dataIndex].user_name}</h4>
          </span>
      }
  }
    },
    {
     name: "email",
     label: "Email",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "mobile_number",
     label: "Mobile",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
      name: "trip_count",
      label: "Trips",
      options: {
       filter: true,
       sort: false,
      }
     },
    {
      name:"is_block",
      label:"Action",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
         // console.log(data[dataIndex])
          const u_id = [data[dataIndex].id];
          let block = "";
          if(data[dataIndex].is_block === 0){
            block = <Button title="Unblock" onClick={()=>userBlock(1,u_id)}>
            <MaterialIcons color="action" icon="verified_user" size={20} />
            </Button>
          }else{
            block = <Button title="Block" onClick={()=>userBlock(0,u_id)}>
            <MaterialIcons color="secondary" icon="verified_user" size={20}/>
            </Button>
          }
          return(
            <div>
               {/* <Button title="verify">
               <MaterialIcons color="secondary" icon="person_add_disabled" size={20}/>
               </Button> */}
               {block}
            </div>
           
          );
        }
       },
    },{
      name:"trip",
      label:"Trip",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite:(value, dataIndex,updateValue) => {
          const u_id = [data[dataIndex].id];
          return(
            <div>
               <Link to={"/user/trip/"+u_id}>
               <MaterialIcons color="secondary" icon="trip_origin_icon" size={20}/>
               </Link>
            </div>
           
          );
        }
       },
    }
   ];
   const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
  //  selectableRows: "none",
    // draggableColumns: {
    //   enabled: true
    // },
    responsive: "standard",
   //  selectedRows: {
   //   text: "row(s) sdsdsdsdsselected",
   //   delete: "Delete",
   //   deleteAria: "Delete Selected Rows",
   // },
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
    //selectToolbarPlacement:"none",
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) =>{
     return (
       <div>
         <Button title="Block" onClick={()=>userBlock(0,srow)}>
           <MaterialIcons color="action" icon="verified_user" size={20}/>
       </Button>
       <Button title="Unblock" onClick={()=>userBlock(1,srow)}>
           <MaterialIcons color="secondary" icon="verified_user" size={20}/>
       </Button>
       </div>
     )
    },
  };

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br}/>
       <h1>User Details</h1>
       <Datatable title="User List" data={data} columns={columns} options={options}/>
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/User.js